import React, { FC } from 'react';

import { IContentLayoutProps } from 'types/app';
import { useContent } from 'hooks';
import { IPostRenderProps } from 'features/posting';

import { getUrl } from '../helpers';
import { EmbedReddit } from '../widgets';
import { Embed } from '../layouts';

interface IPropsEnhanced extends IContentLayoutProps, IPostRenderProps {}

const Reddit: FC<IPropsEnhanced> = props => {
  const content = useContent();
  const url = getUrl(content);

  return (
    <Embed {...props}>
      <EmbedReddit url={url} />
    </Embed>
  );
};

export default Reddit;
